import {breadcrumbKey} from "element-plus";

export default {
    test:test,
    getMaxValue:getMaxValue,
    getMaxValue1:getMaxValue1,
    getDivisor:getDivisor,
    getCurrentYearByMonth:getCurrentYearByMonth,
    getPieSum:getPieSum,
    getChartDataKey:getChartDataKey,
    getDateLabel:getDateLabel,
    getLastDay:getLastDay,
    getYearly:getYearly
}

function test(){
    return "测试！！"
}

function getMaxValue(list1,list2){
    let max = 0
    let mergedList = list1.concat(list2)
    mergedList.forEach((value) => {
        if (value >= 0) {
            if (value > max){
                max = value
            }
        }
    })
    return max

}
function getMaxValue1(list1,list2,list3){
    let max = 0
    let mergedList = list1.concat(list2, list3)
    mergedList.forEach((value) => {
        if (value >= 0) {
            if (value > max){
                max = value
            }
        }
    })
    return max

}

function getDivisor(res){

    if (res < 10){
        return 10
    }else if (res < 50) {
        return 50
    }else {
        return 100
    }
}

function getCurrentYearByMonth(){
    let date = new Date()

   /* if((date.getUTCMonth() + 1) < 4){
        return date.getUTCFullYear() - 1
    }else {
        return  date.getUTCFullYear()
    }*/
    return  date.getUTCFullYear()

}

function getPieSum(res){
    let sum = 0
    if (typeof res !== "undefined") {
        res.forEach((item) => {
            if (typeof item !== "undefined") {
                sum += parseFloat(item.value)
            }
        })
    }
    return Number(sum.toFixed(0))
}

function getChartDataKey(res){
    switch (res.seriesName){
        case "日不良数量":
        case "一次不良":
            return "badNum"
        case "二次不良":
            return "badNumTwo"
        case "日不良率":
        case "实绩":
            return "badPercent"
        case "自责":
            return "selfReproach"
        case "他责":
            return "otherReproach"
        case "不良数量":
            return "xData"
        case "再手配重量":
        case "再手配数量":
        case "不良单元数量":
        case "单元不良项数量":
            return "series"
        case "不良单元数量/面积":
        case "单元不良项/面积":
            return "seriesLine"
    }
}

function getDateLabel(res){
    if (res >= 10){
        return res.toString();
    }else {
        return '0' + res.toString();
    }
}

function getLastDay(res){
    if (res.day === "01"){

        if (res.month === "01"){
            res.year =  (new Date().getUTCFullYear() - 1).toString()
            res.day = getDateLabel(new Date(res.year,1,0).getDate())
            res.month = "12"
        }else {
            res.month = getDateLabel(res.month - 1)
            res.day = getDateLabel(new Date(res.year,res.month,0).getDate())
        }
    }else {
        res.day = getDateLabel(res.day - 1)
    }
    return res;
}

function getYearly(){
    let date = new Date()

     if((date.getUTCMonth() + 1) < 4){
        return date.getUTCFullYear() - 1
    }else {
        return  date.getUTCFullYear()
    }
}